/**
 * @citeclerk/ui — LegalLinks.jsx. RUN PX AMENDMENT.
 *
 * ═══════════════════════════════════════════════════════════════════════════════════════════════
 * Terms + Privacy, on every modal that takes money or shows the outcome of taking money — the
 * subscription checkout, the à la carte checkout, and the purchase confirmation modal (both faces).
 * Adam's rule: a customer must be able to reach the terms they are agreeing to from the screen
 * where they agree to them, and that is a legal requirement, not a footer nicety.
 *
 * 🔴 SAME HREFS THE GLOBAL FOOTER USES — `/terms` and `/privacy` (public/_footer.html:40-41) — and
 * the SAME link text ("Terms" / "Privacy"). No new route, no new copy.
 *
 * 🔴 OPENS IN A NEW TAB, DELIBERATELY. The footer's own links navigate in place, which is fine on a
 * static page with nothing to lose. Inside a checkout modal that would abandon a card mid-entry —
 * reading the terms should never cost someone the card they were typing. `rel="noopener noreferrer"`
 * so the new tab cannot reach back into this window.
 *
 * Link colour is `--cc-accent-text`, the same token CardSheet.jsx's own `.cc-cs-link` already uses —
 * no new hex, per the raw-colour gate.
 */
import React, { useEffect } from 'react';

const STYLE = {
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
  fontSize: 12, color: 'var(--cc-ink-muted, #6B86B5)', padding: '2px 0',
};

// Same focus-ring idiom AccountPanel.css already uses (RUN AE): a visible halo on :focus-visible,
// invisible on a mouse click. One small stylesheet, injected once per bundle.
const CSS = `
.cc-legal-link{color:var(--cc-accent-text,#003A8F);text-decoration:underline;text-underline-offset:2px;border-radius:2px}
.cc-legal-link:focus-visible{outline:none;box-shadow:0 0 0 2px var(--cc-focus-halo-light,rgba(0,58,143,.35)),0 0 0 5px var(--cc-focus-halo-dark,rgba(0,58,143,.15))}
`;
let _css = false;
function useLegalLinksCss() {
  useEffect(() => {
    if (_css || typeof document === 'undefined') return;
    const el = document.createElement('style'); el.dataset.ccLegal = '1'; el.textContent = CSS;
    document.head.appendChild(el); _css = true;
  }, []);
}

export default function LegalLinks() {
  useLegalLinksCss();
  return (
    <p className="cc-legal-links" style={STYLE}>
      <a href="/terms" className="cc-legal-link" target="_blank" rel="noopener noreferrer">Terms</a>
      <span aria-hidden="true">&middot;</span>
      <a href="/privacy" className="cc-legal-link" target="_blank" rel="noopener noreferrer">Privacy</a>
    </p>
  );
}
